<template>
  <section class="main">
    <div class="header">我的消息详情</div>
    <div class="msglist">
      <div class="info">
        <div class="title">{{msgInfo.title}}【{{msgInfo.subject}}】</div>
        <div class="time">{{msgInfo.send_time | formateTime}}</div>
      </div>
      <div class="msgDesc" v-html="msgInfo.content">{{msgInfo.content}}</div>
    </div>
  </section>
</template>

<script>
import "@/styles/userIndex.scss";
import { messageDetail, setMsgReaded } from "@/api/user.js";

export default {
  props: {
    id: Number
  },
  data() {
    return {
      index: 1,
      msgInfo: {}
    };
  },
  mounted() {
    this.loadData(this.id);
  },
  methods: {
    loadData: function(id) {
      messageDetail(id).then(resp => {
        if (resp != -1) {
          this.msgInfo = resp;
        }
      });

      setMsgReaded(id).then(resp => {});
    }
  },
  filters: {
    formateTime: function(value) {
      if (value == undefined) {
        return;
      }
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "." + MM + "." + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
body {
  background: #efefef;
}
.msglist {
  .info {
    background: #efefef;
    margin: 20px;
    padding: 10px;
    .title,
    .time {
      font-size: 1.4em;
      color: #595858;
      height: 26px;
      line-height: 26px;
    }
  }
  .msgDesc {
    font-size: 1.4em;
    color: #595858;
    margin: 20px;
    padding: 10px;
  }
}
</style>